import React, { useEffect, useState } from "react";
import { getAdminToken, onAdminAuthChange } from "../lib/adminAuth";
import AdminAccess from "../pages/AdminAccess";

export default function RequireAdmin({ children }) {
  const [token, setToken] = useState(getAdminToken());
  useEffect(() => onAdminAuthChange(() => setToken(getAdminToken())), []);
  if (!token) return <AdminAccess />;
  return children;
}
